import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19 5c8.836 0 16 7.164 16 16h2c0-9.94-8.06-18-18-18v2Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19 12.559c4.656 0 8.442 3.785 8.442 8.441h2c0-5.76-4.681-10.441-10.442-10.441v2Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m9.157 9.293-.707-.707-4.696 4.696A2.546 2.546 0 0 0 3 15.147c.157 5.947 2.498 11.465 6.443 15.409 3.953 3.95 9.48 6.286 15.41 6.443a2.546 2.546 0 0 0 1.864-.753l4.696-4.696-6.377-6.377a2.605 2.605 0 0 0-3.684 0l-1.888 1.888-.807.806-6.525-6.525 2.694-2.694a2.605 2.605 0 0 0-.001-3.685 5736.79 5736.79 0 0 1-5.669-5.67Zm-3.989 5.403 3.282-3.282 1.563 1.565 3.4 3.4a.605.605 0 0 1 0 .855l-4.109 4.108 9.354 9.354.707-.707 1.512-1.512 1.89-1.89a.605.605 0 0 1 .856 0l4.963 4.963-3.282 3.282a.547.547 0 0 1-.398.168c-5.443-.144-10.475-2.287-14.048-5.859C7.292 25.577 5.144 20.554 5 15.094a.547.547 0 0 1 .168-.398Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramValuationCalls40 = createIcon(IconComponent);